import React, { useContext, useEffect, useState } from 'react'
import { getDefaults } from 'services/login';
import { message } from 'antd';
import { createGlossaryTerm } from 'services/help';
import { AppContext } from 'context/AppContext';


const TokenExpired = (props) =>{

    let appContext = useContext(AppContext);


    const [messageApi, contextHolder] = message.useMessage();
    const [getStartTimeToken,setGetStartTimeToken] = useState(Date.now())
    const [getReqDefaults, setGetReqDefaults] = useState(false)

    useEffect(()=>{

        if(!sessionStorage.getItem('startTimeToken')){
            sessionStorage.setItem('startTimeToken', Date.now())
        }
        if(getReqDefaults){
            getDefaults()
            .then()
            .catch((err) => {
                let errCode = err.response.status;

                    if (errCode == 401 ) {
                        const success = () => {
                            message
                                .error(
                                    'Your Access token has expired!',
                                    2.5
                                )
                                .then(()=>{
                                    message.loading('Loging Out....', 3)

                                })
                                .then(()=>{
                                    setTimeout(() => {
                                        props.setAccessTokenSessionStore(null);
                                        localStorage.clear();
                                        sessionStorage.clear();
                                        window.location.href =
                                            '/app/login/';
                                    }, 1500);
                                })
                                
                        };
                        success();
                }
            });
        }
    },[getReqDefaults])

    window.addEventListener('focus', ()=>{
    // console.log(`addEventListener: focus`)
        // console.log(`appContext`,appContext)
        // console.log(sessionStorage.getItem('latest_commit'))

            setTimeout(()=>{
        if(sessionStorage.getItem('accessToken') && (Date.now() - getStartTimeToken) / 1000 >= 605000){
            // console.log(`in if`)
            // console.log((Date.now() - getStartTimeToken) / 1000)

            setGetReqDefaults(true)

            
            // getDefaults()
            //         .then()
            //         .catch((err) => {
            //             let errCode = err.response.status;

            //                 if (errCode == 401 ) {
            //                     const success = () => {
            //                         message
            //                             .error(
            //                                 'Your Access token has expired! test',
            //                                 2.5
            //                             )
            //                             .then(() => {
            //                                 messageApi.open({
            //                                     type: 'loading',
            //                                     content: 'Loging Out..',
            //                                     duration: 1.5
            //                                 });
            //                                 setTimeout(() => {
            //                                     props.setAccessTokenSessionStore(null);
            //                                     localStorage.clear();
            //                                     sessionStorage.clear();
            //                                     window.location.href =
            //                                         '/app/login/';
            //                                 }, 1500);
            //                             });
            //                     };
            //                     success();
            //             }
            //         });
        }else {
            // console.log('in else')
        }
    },2000)

    })
    // console.log(`end getReqDefaults`,getReqDefaults)



    return(
        <>
            {contextHolder}
        </>
    )
}

// export default TokenExpired

export default React.memo(TokenExpired)